<fgb-page-header [pageTitle]="'leaderboard.title'" [showBalance]="false" />
<div class="container mt-lg-4">
  <div class="font-size-14 mb-3 text-white">
    {{ 'leaderboard.description' | translate }}
  </div>

  <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType"></fgb-leaderboard>
</div>
